import {
    Component,
    Input,
    Output,
    ElementRef,
    OnChanges,
    AfterViewInit,
    EventEmitter
} from '@angular/core';

import { Product, ProductSelectedEvent } from "../model/product";
import { SubProduct } from "../model/subproduct";
import { ProductGroup } from "../model/product.group";
import { EventsService } from "../services/events.service";
import { Logger } from "../utils/logger";
import { CONFIG } from "../config";

@Component({
    selector: 'product',
    templateUrl: "./product.component.html"
})
export class ProductComponent implements AfterViewInit, OnChanges {
    @Input()
    public product;

    @Input()
    public subProduct;

    @Input()
    public priceUnit;

    @Input("columns")
    public columns;

    @Input("showPrice")
    public showPrice = true;

    @Input("group")
    public productGroup;

    @Input("side")
    public side = "left";

    @Input()
    public productColumns;

    @Output('onProductInfo')
    public productInfo: EventEmitter<Product>;

    @Output('onProductSelected')
    public productSelected: EventEmitter<ProductSelectedEvent>;

    public isLoadingShow = false;

    public config;

    constructor(public el: ElementRef, public eventBus: EventsService, public logger: Logger) {
        this.productInfo = new EventEmitter<Product>();
        this.productSelected = new EventEmitter<ProductSelectedEvent>();

        this.config = CONFIG;
    }

    ngAfterViewInit(): any {
        this.updateProducts();
    }

    ngOnChanges(changes: any): any {
        if (typeof changes.product !== 'undefined' && changes.product.currentValue) {
            this.eventBus.on("products.renderImageLoaded." + this.product.id.getValue() + "-" + this.product.articleNumber.getValue(), this.onProductImageLoaded, this);
            this.updateProducts();
        }
    }

    showProductInfo(product: Product) {
        this.productInfo.emit(product);
    }

    onSelected(event: Event, product: Product, subProduct: SubProduct, group: ProductGroup) {
        if ((event.target as HTMLElement).className.toLowerCase() !== 'info') {
            this.showProductSpinner();
            this.productSelected.emit({ product: product, subProduct: subProduct, productGroup: group });
        }
    }

    public showProductSpinner() {
        this.isLoadingShow = true;
    }

    onProductImageLoaded(event: { product: Product, groupName: string }) {
        if (this.product) {
            this.isLoadingShow = false;
        }
    }

    updateProducts() {
        let img = this.el.nativeElement.querySelector('.product-img');

        if (!img) {
            return;
        }

        img.addEventListener('load', () => {
            $(img).animate({ opacity: 1 }, 500);
        });

        if (this.product.thumbPath1.getValue() != '') {
            img.src = this.product.thumbPath1.getValue();
        } else {
            img.src = this.product.thumbPath.getValue();
        }

        /*
            if (this.productGroup.getAltNumber() == 1) {
                img.src = this.product.thumbPath2.getValue();
            } else if (this.product.thumbPath1.getValue() != '') {
                img.src = this.product.thumbPath1.getValue();
            } else {
                img.src = this.product.thumbPath.getValue();
            }
        */
    }

}



// WEBPACK FOOTER //
// ./src/app/sidebar/product.component.ts